export default __webpack_public_path__ + "static/media/Lato-Italic.0b4ed003.ttf";